import { useState, useEffect, useRef } from 'react';

type ScrollDirection = 'up' | 'down';

export function useScrollDirection(threshold = 10) {
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>('up');
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const currentY = window.scrollY;

      // Always show header near top of page
      if (currentY < 60) {
        setScrollDirection('up');
        lastScrollY.current = currentY;
        return;
      }

      const diff = currentY - lastScrollY.current;

      // Prevent bounce-back at bottom of page
      const atBottom = (window.innerHeight + currentY) >= (document.documentElement.scrollHeight - 10);
      if (atBottom) {
        lastScrollY.current = currentY;
        return;
      }

      if (diff < 0) {
        setScrollDirection('up');
        lastScrollY.current = currentY;
        return;
      }

      if (diff >= threshold) {
        setScrollDirection('down');
        lastScrollY.current = currentY;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrollDirection;
}
